import { IFilter } from '../../types/advancedFilters';
import { CompletionYearContainer } from '../../containers/advancedFilters/CompletionYearContainer';

export const completionYear: IFilter = {
  component: CompletionYearContainer,
};
